export enum DateRangeTypeApiEnum {
    RELATIVE = 'RELATIVE',
    RELATIVE_TIMEZONE = 'RELATIVE_TIMEZONE',
    ABSOLUTE = 'ABSOLUTE',
    ALL = 'ALL',
}
